import { render, staticRenderFns } from "./TabsSection.vue?vue&type=template&id=3a08496a&"
import script from "./TabsSection.vue?vue&type=script&lang=js&"
export * from "./TabsSection.vue?vue&type=script&lang=js&"
import style0 from "./TabsSection.vue?vue&type=style&index=0&id=3a08496a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports